import { render, staticRenderFns } from "./DialogTree.vue?vue&type=template&id=f0a48e96"
import script from "./DialogTree.vue?vue&type=script&lang=js"
export * from "./DialogTree.vue?vue&type=script&lang=js"
import style0 from "./DialogTree.vue?vue&type=style&index=0&id=f0a48e96&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports